var _defs, _path, _path2, _circle, _path3, _path4, _circle2, _path5, _path6, _circle3, _path7, _path8, _circle4, _path9, _path10, _circle5, _path11, _circle6, _circle7, _path12, _path13, _circle8, _path14, _path15, _circle9, _path16, _path17, _circle10, _path18, _path19, _path20, _path21, _path22, _path23, _path24;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockerLarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.47,
    height: 34.74,
    viewBox: "0 0 13.47 34.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#767571;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,0V33.61H13.47V0H0ZM12.38,32.52H1.09V1.09H12.38v31.43Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2.84,14.94c-.3,0-.55,.24-.55,.55v2.63c0,.3,.24,.55,.55,.55s.55-.24,.55-.55v-2.63c0-.3-.24-.55-.55-.55Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 5.09,
    cy: 3.49,
    r: 0.56
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.53,4.04c.3,0,.55-.25,.55-.55s-.25-.55-.55-.55-.55,.25-.55,.55,.25,.55,.55,.55Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M9.98,4.04c.3,0,.55-.25,.55-.55s-.25-.55-.55-.55-.55,.25-.55,.55,.25,.55,.55,.55Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 5.09,
    cy: 6.44,
    r: 0.56
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.53,6.99c.3,0,.55-.25,.55-.55s-.25-.55-.55-.55-.55,.25-.55,.55,.25,.55,.55,.55Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M9.98,6.99c.3,0,.55-.25,.55-.55s-.25-.55-.55-.55-.55,.25-.55,.55,.25,.55,.55,.55Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 5.09,
    cy: 9.38,
    r: 0.56
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.53,9.94c.3,0,.55-.25,.55-.55s-.25-.55-.55-.55-.55,.25-.55,.55,.25,.55,.55,.55Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M9.98,9.94c.3,0,.55-.25,.55-.55s-.25-.55-.55-.55-.55,.25-.55,.55,.25,.55,.55,.55Z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 5.09,
    cy: 12.33,
    r: 0.56
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.53,12.88c.3,0,.55-.25,.55-.55s-.25-.55-.55-.55-.55,.25-.55,.55,.25,.55,.55,.55Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M9.98,12.88c.3,0,.55-.25,.55-.55s-.25-.55-.55-.55-.55,.25-.55,.55,.25,.55,.55,.55Z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 5.09,
    cy: 15.28,
    r: 0.56
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.53,15.83c.3,0,.55-.25,.55-.55s-.25-.55-.55-.55-.55,.25-.55,.55,.25,.55,.55,.55Z"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 9.98,
    cy: 15.28,
    r: 0.55
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 5.09,
    cy: 18.22,
    r: 0.56
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.53,18.77c.3,0,.55-.25,.55-.55s-.25-.55-.55-.55-.55,.25-.55,.55,.25,.55,.55,.55Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M9.98,18.77c.3,0,.55-.25,.55-.55s-.25-.55-.55-.55-.55,.25-.55,.55,.25,.55,.55,.55Z"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 5.09,
    cy: 21.17,
    r: 0.56
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.53,21.72c.3,0,.55-.25,.55-.55s-.25-.55-.55-.55-.55,.25-.55,.55,.25,.55,.55,.55Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M9.98,21.72c.3,0,.55-.25,.55-.55s-.25-.55-.55-.55-.55,.25-.55,.55,.25,.55,.55,.55Z"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 5.09,
    cy: 24.11,
    r: 0.56
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.53,24.66c.3,0,.55-.25,.55-.55s-.25-.55-.55-.55-.55,.25-.55,.55,.25,.55,.55,.55Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M9.98,24.66c.3,0,.55-.25,.55-.55s-.25-.55-.55-.55-.55,.25-.55,.55,.25,.55,.55,.55Z"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 5.09,
    cy: 27.06,
    r: 0.56
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.53,27.61c.3,0,.55-.25,.55-.55s-.25-.55-.55-.55-.55,.25-.55,.55,.25,.55,.55,.55Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M9.98,27.61c.3,0,.55-.25,.55-.55s-.25-.55-.55-.55-.55,.25-.55,.55,.25,.55,.55,.55Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M5.09,29.44c-.31,0-.56,.25-.56,.57s.25,.57,.56,.57,.56-.25,.56-.57-.25-.57-.56-.57Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.53,30.56c.3,0,.55-.25,.55-.55s-.25-.55-.55-.55-.55,.25-.55,.55,.25,.55,.55,.55Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M9.98,30.56c.3,0,.55-.25,.55-.55s-.25-.55-.55-.55-.55,.25-.55,.55,.25,.55,.55,.55Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.44,33.63c-.3,0-.55,.25-.55,.55s.25,.55,.55,.55,.55-.25,.55-.55-.25-.55-.55-.55Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M12.03,33.63c-.3,0-.55,.25-.55,.55s.25,.55,.55,.55,.55-.25,.55-.55-.25-.55-.55-.55Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockerLarge);
export default __webpack_public_path__ + "static/media/LockerLarge.271a454e9d34cf76537b5d9dc7f97f2c.svg";
export { ForwardRef as ReactComponent };